import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['parentSection', 'objectsToObserve', 'backupElement'];

  connect() {
    const observer = new MutationObserver(() => {
      this.updateDisplay();
    });

    observer.observe(this.parentSectionTarget, {
      childList: true,
      subtree: true,
    });
  }

  updateDisplay() {
    // If any of the objects to observe are visible, hide the backup element
    if (
      this.objectsToObserveTargets.some(
        (target) => target.offsetParent !== null
      )
    ) {
      this.backupElementTarget.classList.add('d-none');
    } else {
      this.backupElementTarget.classList.remove('d-none');
    }
  }
}
